import { on_ready, is_elementor_edit } from 'js/utils';
import { hover_intent } from 'js/functions';
// import { add_to_cart_ajax_init } from 'src/woocommerce/js/add_to_cart';
// import { load_swiper_mobile } from 'modules/carousel/load_swiper_mobile';

import './internals.scss';

on_ready(()=>{

    if( is_elementor_edit() ) return;

    // add_to_cart_ajax_init();

    // load_swiper_mobile();
    
    // add delay on hover out - to avoid instant close/off
    hover_intent_init();

    add_warranty();
    //group_warranty();
    ['gr-1', 'gr-2', 'gr-3'].forEach(group => groupWarranty(group));

    initNestedTabNext();

    initStorePrevPageAndPopupExit();


});

function hover_intent_init(){
    document.querySelectorAll('.hover_intent').forEach(el=>{
        const duration = el.dataset.duration || 300;
        hover_intent(el, duration);
    });
}

function add_warranty(){
    const button_warranty = document.querySelector('.add-warranty-button');
    if(!button_warranty) return;

    button_warranty.addEventListener('click', () => {
 
        let current_count = parseInt(button_warranty.dataset.target, 10);
        let last_count = parseInt(button_warranty.dataset.last, 10);


        for (let i = current_count; i < current_count + 5; i++) {
            const el = document.querySelector(`.hide-${i}`);
            if (el) el.classList.remove('hide');
        }
 
        let new_count = current_count + 5;
        button_warranty.dataset.target = new_count;
 
        if (new_count >= last_count) {
            button_warranty.disabled = true;
            button_warranty.classList.add('disabled');
        }
    });

}


/*
function group_warranty(){ 

    const fields = document.querySelectorAll('.gfield.gr-3');
    if (!fields.length) return;

    const wrapper = document.createElement('div');
    wrapper.classList.add('grouped-gr-3', 'grouped-gr' ,'active');

    fields[0].parentNode.insertBefore(wrapper, fields[0]);
    fields.forEach(field => wrapper.appendChild(field));
 
    const innerItems = wrapper.querySelectorAll('.gr-item');

    let innerWrapper = null;
    if (innerItems.length) {
        innerWrapper = document.createElement('div');
        innerWrapper.classList.add('grouped-items');

        innerItems[0].parentNode.insertBefore(innerWrapper, innerItems[0]);
        innerItems.forEach(item => innerWrapper.appendChild(item));
    } 

    const ddForms = wrapper.querySelector('.dd-form');
     
    ddForms.addEventListener('click', function (e) {
        wrapper.classList.toggle('active'); 
    });  

}*/

function groupWarranty(groupClass) {

    const fields = document.querySelectorAll(`.gfield.${groupClass}`);
    if (!fields.length) return;

    const wrapper = document.createElement('div');
    wrapper.classList.add(`grouped-${groupClass}`, 'grouped-gr', 'active');

    fields[0].parentNode.insertBefore(wrapper, fields[0]);
    fields.forEach(field => wrapper.appendChild(field));

    const innerItems = wrapper.querySelectorAll('.gr-item');

    let innerWrapper = null;
    if (innerItems.length) {
        innerWrapper = document.createElement('div');
        innerWrapper.classList.add('grouped-items');

        innerItems[0].parentNode.insertBefore(innerWrapper, innerItems[0]);
        innerItems.forEach(item => innerWrapper.appendChild(item));
    }

    const ddForms = wrapper.querySelector('.dd-form');
    if (ddForms) {
        ddForms.addEventListener('click', () => {
            wrapper.classList.toggle('active');
        });
    }
}

function initNestedTabNext() {
    const processTabWidgets = document.querySelectorAll('.elementor-element.process-tab.e-n-tabs-mobile');

    processTabWidgets.forEach(widget => {
        const parentTabButtons = widget.querySelectorAll('.e-n-tabs-heading > .e-n-tab-title');

        // Only loop through first 3 parent tabs if needed
        for (let i = 0; i < 3 && i < parentTabButtons.length; i++) {
            const parentTab = parentTabButtons[i];

            // Get the content container of this parent tab
            const tabContentId = parentTab.getAttribute('aria-controls');
            const tabContent = document.getElementById(tabContentId);
            if (!tabContent) return;

            // Find the nested tab container inside this parent tab
            const nestedTabContainer = tabContent.querySelector('.e-n-tabs');
            if (!nestedTabContainer) return;

            const nestedTabButtons = nestedTabContainer.querySelectorAll('.e-n-tab-title');
            if (!nestedTabButtons.length) return;

            const lastNestedTab = nestedTabButtons[nestedTabButtons.length - 1];

             // Click listener for last nested tab
            lastNestedTab.style.position = 'relative';

            // remove previous overlay if exists
            let arrowOverlay = lastNestedTab.querySelector('.arrow-click-box');
            if (!arrowOverlay) {
                arrowOverlay = document.createElement('div');
                arrowOverlay.className = 'arrow-click-box';

                const arrowWidth = 110;       // pseudo-element width
                const arrowHeight = 60;       // pseudo-element height
                const arrowLeft = 110;        // left offset of pseudo-element
                const arrowTranslateY = 80;  // match CSS transform translateY

                // Compute top relative to tab
                const arrowTop = arrowTranslateY; // adjust if needed

                Object.assign(arrowOverlay.style, {
                    position: 'absolute',
                    top: `${arrowTop}px`,      
                    left: `${arrowLeft}px`,
                    width: `${arrowWidth}px`,
                    height: `${arrowHeight}px`,
                    cursor: 'pointer',
                    zIndex: '999',
                    background: 'rgba(0,0,0,0)' // debug overlay
                });

                lastNestedTab.appendChild(arrowOverlay);

                arrowOverlay.addEventListener('click', () => {
                    console.log("Arrow clicked on last nested tab of parent tab:", parentTab.textContent.trim());

                    const currentIndex = Array.from(parentTabButtons).findIndex(
                        btn => btn.getAttribute('aria-selected') === 'true'
                    );

                    if (currentIndex >= 0 && currentIndex < parentTabButtons.length - 1) {
                        const nextParentTab = parentTabButtons[currentIndex + 1];
                        nextParentTab.dispatchEvent(new Event('click', { bubbles: true }));
                    }
                });
            }

        }
    });
}

function initStorePrevPageAndPopupExit() {

    // Store previous page when user clicks a button leading to gated page
    document.addEventListener('click', (e) => {
        const btn = e.target.closest('.store-prev-page a');
        if (btn) {
            sessionStorage.setItem('preLoginPage', window.location.href);
        }
    });

    // Delegated click for any popup close
    document.addEventListener('click', (e) => {
        const popupClose = e.target.closest('.elementor-popup__close, .popup-exit-gated a');
        if (!popupClose) return;

        e.preventDefault();

        // Get the stored previous page
        const prev = sessionStorage.getItem('preLoginPage');

        // Clear after using
        sessionStorage.removeItem('preLoginPage');

        // Redirect to previous page if exists, otherwise homepage
        window.location.href = prev || '/';
    });
}